"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeEntriesWithUndefinedValue = void 0;
function removeEntriesWithUndefinedValue(obj) {
    if (!obj)
        return null;
    const entries = Object.entries(obj);
    const filteredEntries = entries.filter((entry) => entry[1]);
    return Object.fromEntries(filteredEntries);
}
exports.removeEntriesWithUndefinedValue = removeEntriesWithUndefinedValue;
//# sourceMappingURL=objects.js.map